/**
 * Created by cookiecoffee on 2018/2/28.
 */
export const isNum = (string) => /^[0-9]+$/.test(string)



// WEBPACK FOOTER //
// ./src/libs/tools.js